import CollectionSearch from '@/js/Shared/Collections/CollectionSearch';

export { FoldersSearchCollection as default };

/**
* Folder IndexEntity
*
* Defines folders index struture
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FoldersSearchCollection extends CollectionSearch {

  /**
   * Last serch term used
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  term;

  /**
   * Sets the id
   *
   * @public
   *
   * @since 7.0.0
   */
  constructor() {
    super('id');
  }

  /**
   * Searchs folders
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} term search term
   *
   * @return {void}
   */
  search(term) {
    this.term = term;
    super.search(term, {
      name: ['lower_case', 'latinize'],
    })
  }

  /**
   * Reloads search items by applying the last search
   *
   * @public
   *   *
   * @since 7.0.0
   *
   * @return {void}
   */
  reload() {
    this.search(this.term);
  }

  /**
   * Resets the Collection
   *
   * @public
   *   *
   * @since 7.0.0
   *
   * @return {void}
   */
  reset() {
    this.term = undefined;
    super.reset();
  }
}